import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { useNotice } from "@/context/NoticeContext";
import { noticeContent } from "@/data/noticeContent";
import { NoticeBody } from "@/components/NoticeBody";

const SEEN_KEY = "nina-notice-seen-v1";

export const NoticeModal = () => {
  const { lang: globalLang } = useLanguage();
  const { open, setOpen } = useNotice();
  const [lang, setLang] = useState(globalLang === "es" ? "es" : "en");

  useEffect(() => {
    setLang(globalLang === "es" ? "es" : "en");
  }, [globalLang]);

  // Auto-open on the visitor's first visit.
  useEffect(() => {
    let seen = null;
    try {
      seen = localStorage.getItem(SEEN_KEY);
    } catch (err) {
      console.warn("Could not read notice flag from localStorage:", err);
      seen = null;
    }
    if (!seen) {
      const t = setTimeout(() => {
        setOpen(true);
        try {
          localStorage.setItem(SEEN_KEY, "1");
        } catch (err) {
          console.warn("Could not persist notice flag to localStorage:", err);
        }
      }, 900);
      return () => clearTimeout(t);
    }
  }, [setOpen]);

  const c = noticeContent[lang];

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-h-[88vh] w-[min(640px,94vw)] overflow-y-auto rounded-3xl border border-[color:var(--border-subtle)] bg-white p-0"
        data-testid="notice-modal"
      >
        <DialogTitle className="sr-only">{c.title}</DialogTitle>
        <DialogDescription className="sr-only">{c.intro}</DialogDescription>
        <NoticeBody content={noticeContent} lang={lang} setLang={setLang} compact />
        <div className="sticky bottom-0 flex justify-end border-t border-[color:var(--border-subtle)] bg-white px-5 py-4 sm:px-6">
          <Button
            onClick={() => setOpen(false)}
            className="h-11 rounded-xl bg-[var(--brand-burgundy)] px-6 font-semibold text-white hover:bg-[var(--brand-burgundy-dark)]"
            data-testid="notice-modal-close"
          >
            {c.close}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NoticeModal;
